import React from 'react';
import './Image.scss';

function Image() {
  return (
    <div className="image"></div>
  );
}

export default Image;